var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = parseFloat(_vm.originalPrice)

  if (!_vm._isMounted) {
    _vm.e0 = function($event) {
      _vm.isNameError = !_vm.testName()
    }

    _vm.e1 = function($event) {
      _vm.isPhoneError = !_vm.testPhone()
    }

    _vm.e2 = function($event) {
      !_vm.submitLoading ? _vm.submit() : ""
    }
  }

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }